import { render, staticRenderFns } from "./md-upload.vue?vue&type=template&id=72725cb5&"
import script from "./md-upload.vue?vue&type=script&lang=js&"
export * from "./md-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports